module.exports = __webpack_public_path__ + "static/img/bigdata22.54796c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigdata22.jpg
// module id = eg1j
// module chunks = 0